
import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUIFlags from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";

export default class BigWin extends State {
    public onEnter() {
        if (this.bigWinTriggered()) {
            this.bigWin().then(() => this.complete());
        } else {
            this.complete();
        }
    }

    public complete() {
        Services.transaction.setWinnings(this.getResultWin()).execute();
        Services.transaction.setTotalWin(this.getTotalWin());

        super.complete();
    }

    protected bigWinTriggered() {
        return Components.bigWin.isBigWin(this.getResultWin(), BetModel.getTotalStake());
    }

    protected bigWin(): Contract<boolean> {

        const gameplay = GameState.getCurrentGame();

        let winnings: number;
        if (gameplay.isCurrentRecordRoot()) {
            winnings = GameState.getCurrentGame().getTotalWin();
        } else {
            winnings = this.getResultWin();
        }
        const stake = BetModel.getTotalStake();

        SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);

        return new Contract<boolean>((resolve) => {
            Components.bigWin.showWin(winnings, stake).then((result) => {
                SmartUIFlags.set(SmartUIFlag.NO_SKIP, false);
                resolve(result);
            });
        });
    }

    protected getResultWin() {
        return GameState.getCurrentGame().getCurrentRecord().cashWon;
    }

    protected getTotalWin() {
        return GameState.getCurrentGame().getCurrentTotalWin();
    }
}
